import { useState, useEffect } from "react";
import "./styles/PanelPortafolio.css";
import Search from "../generales/Search";
import Action from "../Action";
import Modal from "react-modal";
import LoadSimple from "../LoadSimple";
import ModalCreateService from "./ModalCreateService";
import TablePortafolioServices from "./TablePortafolioServices";
import InfoPortafolio from "./InfoPortafolio";
import Paginador from "../generales/Paginador";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "25%",
    height: "60%",
    padding: "20px",
    borderRadius: " 4px !important"
  },
};
const PanelPortafolio = ({ server,
  ServiceSelected,
  setServiceSelected,
  languaje,
  mode,
  handleShowPopup
}) => {


  const [devices, setDevices] = useState({
    data: [],
    loading: true,
    error: null,
  });


  const [listSelected, setListSelected] = useState(1);
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [dataObject, setDataObject] = useState({
    data: [],
    loading: true,
    error: null,
  })
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  var dataList = searchTerm === "" ? dataUsers.data : searchResults;

  const [searchResult, setSearchResult] = useState(null);
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const startLimit = limitList * pageActual - limitList;
  const [CreateServiceModalOpen, setCreateServiceModalOpen] = useState(false);
  const pages = parseInt(dataList.length / limitList) + 1;



  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataCis, setDataCis] = useState([]);
  const [loadingCis, setLoadingCis] = useState(false);
  const [errorCis, setErrorCis] = useState(null);

  const [editActive, setEditActive] = useState(false);
  const [dataService, setDataService] = useState([]);

  const [loadCatalogo, setLoadCatalogo] = useState(false)
  const [loadPlantilla, setLoadPlantilla] = useState(false)
  const [sla, setSla] = useState('0')
  const handleSelectChange = (e) => {
    setLimitList(e.target.value); setPageActual(1);
  };


  const hadleChangeList = (e) => {
    setListSelected(e);
  };
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setSearchResult(`Resultados para: ${query}`);
  };

  const crear = () => {
    setCreateServiceModalOpen(true);
  };


  useEffect(() => {
    setPageActual(1);
  }, [dataList]);



  useEffect(() => {
    // search_services();
  }, []);

  const regresar_cis = () => {
    setServiceSelected([]);
    // setLoadingCis(true)
  };


  function closCreateServiceModal() {
    setEditActive(false);
    setCreateServiceModalOpen(false);
  }
  const handleChangEdit = (element) => {

    setEditActive(true);
    setDataService(element);
    setCreateServiceModalOpen(true);
  };
  const token_item = localStorage.getItem('access_token')

  function download_plantilla_carga() {
    setLoadPlantilla(true)
    let baseURL

    baseURL = server.url + '/api/v1/cassia/services/plantilla_carga_portafolio';

    const fetchData = async () => {
      try {
        //  const response = await fetch(server.url+'/api/v1/cassia/reports/availability?municipality_id='+opciones.municipio+'&tech_id='+opciones.tecnologia+'&brand_id='+opciones.marca+'&model_id='+opciones.modelo+'&init_date='+opciones.fecha_ini+'&end_date='+opciones.fecha_fin, {     
        const response = await fetch(baseURL, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });

        if (response.ok) {
          try {
            const response_data = await response.blob();
            const url = window.URL.createObjectURL(response_data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'plantilla_carga_portafolio.xlsx'); // Cambia el nombre y la extensión del archivo
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            setLoadPlantilla(false)
          } catch (error) {
            console.error('Error al descargar el archivo', error);
          }

        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
      }
    };
    fetchData();
  }
  function download_catalogo() {
    setLoadCatalogo(true)
    let baseURL

    baseURL = server.url + '/api/v1/cassia/services/catalogo_dispositivos_cassia';

    const fetchData = async () => {
      try {
        //  const response = await fetch(server.url+'/api/v1/cassia/reports/availability?municipality_id='+opciones.municipio+'&tech_id='+opciones.tecnologia+'&brand_id='+opciones.marca+'&model_id='+opciones.modelo+'&init_date='+opciones.fecha_ini+'&end_date='+opciones.fecha_fin, {     
        const response = await fetch(baseURL, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });

        if (response.ok) {
          try {
            const response_data = await response.blob();
            const url = window.URL.createObjectURL(response_data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'catalogo_dispositivos.xlsx'); // Cambia el nombre y la extensión del archivo
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            setLoadCatalogo(false)
          } catch (error) {
            console.error('Error al descargar el archivo', error);
          }

        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
      }
    };
    fetchData();
  }
  return (
    <>
      <div className="head-cis">
        <div className="title-cis">
          <Search
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            onSearch={handleSearch}
            dataObject={dataUsers.data}
            setDataObject={setDataUsers}
            searchResult={searchResult}
            setSearchResult={setSearchResult}
            languaje={languaje}
          />
          <div className={"cont-result-registers" + mode}>

            <p style={{ textAlign: "center" }}>
              &nbsp;
              {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados']) + " (" +
                dataList.length +
                ") "
              }
            </p>
          </div>
          <div className="cont-buttons-panel">

            <Action
              disabled={false}
              origen="Azul"
              titulo={"+ " + capitalizeFirstLetter(lang[languaje]['nuevoServicio'])}
              action={crear}
            />


          </div>
        </div>
      </div>
      <div className="cont-cis">
        <div className="main-panel-portafolio">
          <div className="compact-content-portafolio">
            <div className={"content-portafolio-head" + mode}>
              {ServiceSelected.length === 0 ? '' :
                <>
                  <div
                    className="cont-btn-back-users"
                    style={{ width: "10%" }}
                    onClick={regresar_cis}
                  >
                    <div className="cont-img-back-users">
                      <img
                        className="img-back-users"
                        src={"/iconos/back.png"}
                        name="regresar"
                      />
                    </div>
                    <div className="cont-txt-back-users">
                      <div className="txt-back-users">{capitalizeFirstLetter(lang[languaje]['regresar'])}</div>
                    </div>
                  </div>
                  <div className="txt-back-users sla-content">{ServiceSelected.service_name}&nbsp;&nbsp;&nbsp;&nbsp;{'     SLA: ' + sla + "%"}</div>
                </>
              }
              <div className="cont-excels-buttons-portafolio" style={{ position: 'absolute' }}>
                <div className="half-excels-buttons-portafolio">

                  <div className="body-half-excels-buttons-portafolio">
                    {
                      (loadCatalogo) ? <LoadSimple></LoadSimple> :
                        <img
                          className="img-dwnld-portafolio"
                          src={"/iconos/xls.png"}
                          name="regresar"
                          onClick={() => download_catalogo()}
                        />
                    }
                  </div>
                  <div className={"top-half-excels-buttons-portafolio" + mode} >
                    {capitalizeFirstLetter(lang[languaje]['catalogo'])}
                  </div>
                </div>
                <div className="half-excels-buttons-portafolio">

                  <div className="body-half-excels-buttons-portafolio">
                    {
                      (loadPlantilla) ? <LoadSimple></LoadSimple> :
                        <img
                          className="img-dwnld-portafolio"
                          src={"/iconos/xls.png"}
                          name="regresar"
                          onClick={() => download_plantilla_carga()}
                        />
                    }
                  </div>
                  <div className={"top-half-excels-buttons-portafolio" + mode} >
                    {capitalizeFirstLetter(lang[languaje]['plantilla'])}
                  </div>
                </div>
              </div>
            </div>
            <div className={"content-portafolio" + mode}>


              <div className="cont-portafolio-table">
                <div className="content-card-portafolio" id="content">
                  {(
                    <>
                      {ServiceSelected.length === 0 ? (
                        <TablePortafolioServices
                          pageActual={pageActual}
                          limitList={limitList} startLimit={startLimit}
                          dataList={dataList}
                          ServiceSelected={ServiceSelected}
                          setServiceSelected={setServiceSelected}
                          registerIsValid={registerIsValid}
                          searchResults={searchResults}
                          setSearchResults={setSearchResults}
                          searchTerm={searchTerm}
                          setSearchTerm={setSearchTerm}
                          dataUsers={dataUsers}
                          setDataUsers={setDataUsers}
                          server={server}
                          setRegisterIsValid={setRegisterIsValid}
                          setData={setData}
                          setLoading={setLoading}
                          setError={setError}
                          devices={devices}
                          setDataService={setDataService}
                          dataService={dataService}
                          handleChangEdit={handleChangEdit}
                          sla={sla}
                          setSla={setSla}
                          languaje={languaje}
                          dataObject={dataObject}
                          setDataObject={setDataObject}
                          mode={mode}
                          handleShowPopup={handleShowPopup}
                        ></TablePortafolioServices>
                      ) : (
                        ("")
                        // <InfoPortafolio
                        //   server={server}
                        //   portfolioSelected={ServiceSelected}
                        //   searchResults={searchResults}
                        //   ServiceSelected={ServiceSelected}
                        //   setServiceSelected={setServiceSelected}
                        //   setSearchResults={setSearchResults}
                        //   searchTerm={searchTerm}
                        //   setSearchTerm={setSearchTerm}
                        //   onSearch={handleSearch}
                        //   dataUsers={dataUsers}
                        //   setDataUsers={setDataUsers}
                        //   registerIsValid={registerIsValid}
                        //   sla={sla}
                        //   setSla={setSla}
                        //   languaje={languaje}
                        //   dataObject={dataObject}
                        //   setDataObject={setDataObject}
                        // ></InfoPortafolio>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className={"content-portafolio-footer" + mode}>
              <div className="cont-display-paginador">
                <Paginador pages={pages}
                  pageActual={pageActual}
                  setPageActual={setPageActual}
                  mode={mode}></Paginador>
              </div>
              <div className="cont-display-paginador">
                <div className={"cont-half-display-paginador" + mode}>
                  <div>
                    <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
                    <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
                      <option value={10}>10</option>
                      <option value={50} >50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>

                </div>
                <div className={"cont-half-display-paginador" + mode}>
                  <p style={{ textAlign: "center" }}>
                    &nbsp;
                    {"(" +
                      (startLimit + 1) +
                      " - " +
                      (dataList.length > parseInt(pageActual) * parseInt(limitList)
                        ? parseInt(pageActual) * parseInt(limitList)
                        : dataList.length) +
                      ")  " + lang[languaje]['de'] + " " +
                      dataList.length +
                      " " + lang[languaje]['resultados']}
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={CreateServiceModalOpen}
        // isOpen={false}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closCreateServiceModal}
        style={CreateCisModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
        <ModalCreateService
          languaje={languaje}
          mode={mode}
          server={server}
          dataUsers={dataUsers}
          editActive={editActive}
          setEditActive={setEditActive}
          setDataService={setDataService}
          dataService={dataService}
          setData={setData}
          loading={loading}
          setLoading={setLoading}
          setError={setError}
          setRegisterIsValid={setRegisterIsValid}
          closCreateManttoModal={closCreateServiceModal}
          handleShowPopup={handleShowPopup}
        ></ModalCreateService>
      </Modal>
    </>
  );
};

export default PanelPortafolio;
